export default {
    getHourGroups: { method: 'get', url: 'hours/hour-groups' },
    postHourGroups: { method: 'post', url: 'hours/hour-groups' },
    putHourGroups: { method: 'put', url: 'hours/hour-groups/{id}' },
    deleteHourGroups: { method: 'delete', url: 'hours/hour-groups/{id}' },
    catalogHealthSummary: { method: 'get', url: 'hours/hour-groups/catalog-health' },
    catalogHealth: { method: 'get', url: 'hours/hour-groups/{id}/catalog-health' },
}
